import { render, staticRenderFns } from "./StatusQuestionIcon.vue?vue&type=template&id=082e3a5e"
import script from "./StatusQuestionIcon.vue?vue&type=script&lang=js"
export * from "./StatusQuestionIcon.vue?vue&type=script&lang=js"
import style0 from "./StatusQuestionIcon.vue?vue&type=style&index=0&id=082e3a5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports